import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestDeleteDocument(data) {
  return fetch.delete(`${BASE_URL}/api/app/document/${data}`);
}